import ActiveAdvanceReceivables from './ActiveAdvanceReceivables';

export default ActiveAdvanceReceivables;
